import React, { useEffect, useState } from "react";
import { useStates } from "../../../hooks/useStatesAndConstituencies";
import { showError, showSuccess } from "../../../utils/toastUtils";
import useNumericInput from "../../../hooks/useNumericInput";
import sportAPI from "../../../api/admin/sportApi";

function EditDetails({ data, onSuccess }) {
  useNumericInput();

  const [formData, setFormData] = useState({
    game_type: "",
    name: "",
    playing_type: "",
    origin: ""
  });

  useEffect(() => {
    if (data) {
      setFormData({
        name: data.name || "",
        game_type: data.gameType || "",
        playing_type: data.playingType || "",
        origin: data.origin || "",
      });
    }
  }, [data]);

  const stateList = useStates();

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    let newErrors = {};

    if (!formData.game_type.trim()) {
      newErrors.game_type = "Please select Game Type.";
    }

    if (!formData.playing_type.trim()) {
      newErrors.playing_type = "Please select Playing Type.";
    }

    if (!formData.name.trim()) {
      newErrors.name = "Please Enter Sport Name.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);

      if (!validate()) return;

      formData.id = data._id;

      const res = await sportAPI.update(formData);
      if (res.code === 200) {
        showSuccess(res.message);
        onSuccess();

        document.getElementById("closeOffcanvasEditBtn").click();
      } else {
        showError(res.message);
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      showError(err.message);
    }
  };
  return (
    <>
      <form
        method="post"
        onSubmit={handleSubmit}
        className="vh-100 d-flex justify-content-between flex-column"
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">Edit Details for {data?.name}</h4>
          <button
            type="button"
            id="closeOffcanvasEditBtn"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <div className="offcanvas-body">
          <div className="row mb-3">
            <div className="col-md-12">
              <label htmlFor="game_type" className="form-label">
                Game Type <span className="text-danger">*</span>
              </label>
              <select
                name="game_type"
                className={`form-select ${
                  errors.game_type ? "is-invalid" : ""
                }`}
                value={formData.game_type}
                onChange={handleChange}
              >
                <option value="">Select Game Type</option>
                <option value="traditional">Traditional</option>
                <option value="conventional">Conventional</option>
              </select>
              {errors.game_type && (
                <div className="invalid-feedback d-block">
                  {errors.game_type}
                </div>
              )}
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-12">
              <label htmlFor="origin" className="form-label">
                Origin 
              </label>
              <select
                name="origin"
                className={`form-select ${errors.origin ? "is-invalid" : ""}`}
                value={formData.origin}
                onChange={handleChange}
              >
                <option value="">Select Your Origin</option>
                {stateList &&
                  stateList.map((item) => (
                    <option key={item._id} value={item._id}>
                      {item.state}
                    </option>
                  ))}
              </select>
              {errors.origin && (
                <div className="invalid-feedback d-block">{errors.origin}</div>
              )}
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-12">
              <label className="form-label">
                Sport Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                name="name"
                className={`form-control ${errors.state ? "is-invalid" : ""}`}
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
              />
              {errors.name && (
                <span className="invalid-feedback d-block">{errors.name}</span>
              )}
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-12">
              <label htmlFor="playing_type" className="form-label">
                Playing Type <span className="text-danger">*</span>
              </label>
              <select
                name="playing_type"
                className={`form-select ${
                  errors.playing_type ? "is-invalid" : ""
                }`}
                value={formData.playing_type}
                onChange={handleChange}
              >
                <option value="">Select Playing Type</option>
                <option value="team">Team</option>
                <option value="individual">Individual</option>
              </select>
              {errors.playing_type && (
                <div className="invalid-feedback d-block">
                  {errors.playing_type}
                </div>
              )}
            </div>
          </div>

          <div className="mb-3">
            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={loading}
            >
              {loading ? "Updating Data..." : "Submit"}
            </button>
          </div>
        </div>
      </form>
    </>
  );
}

export default EditDetails;
